var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboarding3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 320,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.169 265.092L79 21M238.339 72.85L30 140M284 178.82h-36.409L61.5 238.8M276.423 262.954L192 21",
    stroke: "#E1ECF8",
    strokeWidth: 14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.322 126.598a5 5 0 013.246-6.422l15.211-4.697a5.007 5.007 0 011.995-.195l5.658.591c.671.07 1.35.004 1.995-.195l21.561-6.657a5.001 5.001 0 001.615-.848l5.197-4.086a4.996 4.996 0 011.616-.848l11.422-3.526a5 5 0 016.2 3.141l4.292 12.399c.313.902.36 1.875.137 2.804l-.864 3.594a4.997 4.997 0 00.137 2.804l7.029 20.305a4.998 4.998 0 001.665 2.318l2.803 2.17a4.998 4.998 0 011.665 2.318l4.692 13.554a5.001 5.001 0 01-3.163 6.386l-11.736 3.858a5.002 5.002 0 01-2.213.208l-4.127-.543a4.986 4.986 0 00-2.213.208l-23.443 7.707a5.013 5.013 0 00-1.941 1.181l-2.839 2.787a5.013 5.013 0 01-1.941 1.181l-15.277 5.023a5 5 0 01-6.283-3.105l-5.434-15.594a5.008 5.008 0 01-.234-2.304l.653-4.921a4.99 4.99 0 00-.22-2.259l-6.321-18.711a5.006 5.006 0 00-1.41-2.132l-3.435-3.062a5.008 5.008 0 01-1.394-2.087l-4.301-12.345z",
    fill: "#2E8DDE",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.705 27.31a5 5 0 013.247-6.423L166.22.426a5 5 0 016.2 3.142l21.556 62.265a5 5 0 01-3.163 6.386l-49.659 16.327a4.999 4.999 0 01-4.087-.436l-22.502-13.173a5 5 0 01-2.196-2.67L101.433 40.88l-4.728-13.57z",
    fill: "url(#onboarding3_svg__paint0_linear_0_7282)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.404 148.091l51.392-15.867a5 5 0 016.2 3.141l21.556 62.266a5 5 0 01-3.163 6.386L76.326 219.49a5 5 0 01-6.307-3.177l-22.615-68.222z",
    fill: "url(#onboarding3_svg__paint1_linear_0_7282)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.606 252.936a5 5 0 013.271-6.35l46.515-14.362a4.999 4.999 0 016.2 3.141l21.556 62.266a5 5 0 01-3.163 6.386l-47.062 15.473a5 5 0 01-6.308-3.177l-21.009-63.377z",
    fill: "url(#onboarding3_svg__paint2_linear_0_7282)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.606 225.936a4.999 4.999 0 013.271-6.35l14.051-4.339a5 5 0 016.217 3.192l7.734 23.121a5 5 0 01-3.261 6.361l-14.108 4.376a5 5 0 01-6.227-3.202l-7.677-23.159z",
    fill: "url(#onboarding3_svg__paint3_linear_0_7282)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.51 262.272a5 5 0 013.233-6.532l64.251-19.49a4.999 4.999 0 016.152 3.082l4.491 12.401a4.999 4.999 0 01-3.293 6.499l-64.339 18.893a5 5 0 01-6.093-3.05l-4.402-11.803z",
    fill: "url(#onboarding3_svg__paint4_linear_0_7282)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M195.254 217.126a5 5 0 013.267-6.349l35.036-10.85a5 5 0 016.163 3.027l8.446 22.612a5 5 0 01-3.171 6.515l-35.814 11.369a5 5 0 01-6.259-3.192l-7.668-23.132z",
    fill: "url(#onboarding3_svg__paint5_linear_0_7282)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.657 44.56a5 5 0 013.22-6.495l18.92-5.841a5 5 0 016.199 3.142L87.552 97.63a5 5 0 01-3.163 6.386l-17.705 5.821a5.001 5.001 0 01-6.258-3.032L37.656 44.56z",
    fill: "url(#onboarding3_svg__paint6_linear_0_7282)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.808 56.56a5 5 0 013.22-6.495l18.92-5.841a5 5 0 016.2 3.142l21.555 62.265a5 5 0 01-3.163 6.386l-17.705 5.821a5.001 5.001 0 01-6.258-3.032L1.809 56.56z",
    fill: "url(#onboarding3_svg__paint7_linear_0_7282)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.5 165.277s-2.461-34.363 18.032-60.275C166.025 79.089 198.5 75.5 198.5 75.5",
    stroke: "#2E8DDE",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeDasharray: "1 11"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.5 173a6.5 6.5 0 100-13 6.5 6.5 0 000 13z",
    fill: "#2E8DDE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192 81.003c1.954 0 16.476-18.127 18.012-21.3A19.918 19.918 0 00212 51c0-11.046-8.954-20-20-20s-20 8.954-20 20c0 2.98.651 5.807 1.82 8.347 1.501 3.265 16.226 21.656 18.18 21.656z",
    fill: "#2E8DDE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M192.5 56a5.5 5.5 0 100-11 5.5 5.5 0 000 11z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding3_svg__paint0_linear_0_7282",
    x1: 102.851,
    y1: 21.418,
    x2: 119.937,
    y2: 86.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E8DDE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8DDE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding3_svg__paint1_linear_0_7282",
    x1: 67.362,
    y1: 219.795,
    x2: 125.388,
    y2: 205.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E8DDE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8DDE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding3_svg__paint2_linear_0_7282",
    x1: 145.428,
    y1: 325.333,
    x2: 175.937,
    y2: 249.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E8DDE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8DDE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding3_svg__paint3_linear_0_7282",
    x1: 219.747,
    y1: 264.533,
    x2: 194.727,
    y2: 209.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E8DDE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8DDE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding3_svg__paint4_linear_0_7282",
    x1: 270.004,
    y1: 261.471,
    x2: 263.726,
    y2: 204.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E8DDE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8DDE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding3_svg__paint5_linear_0_7282",
    x1: 271.491,
    y1: 254.691,
    x2: 258.445,
    y2: 197.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E8DDE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8DDE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding3_svg__paint6_linear_0_7282",
    x1: 33.966,
    y1: 99.969,
    x2: 82.609,
    y2: 115.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E8DDE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8DDE",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "onboarding3_svg__paint7_linear_0_7282",
    x1: 24.139,
    y1: 105.888,
    x2: 46.679,
    y2: 111.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E8DDE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8DDE",
    stopOpacity: 0.05
  })))));
}
export default SvgOnboarding3;